import axios from 'axios';
import { Configs } from 'models/app';
import { DownloadableManuals, LookAndFeel } from 'models/response';
import { trackPromise } from 'react-promise-tracker';

import { CINISERVICE } from '../utils/constants';

/**
 * This API return configs data by User and Program
 * @param {number} idUser
 * @param {number} idProgram
 * @return {Promise<AxiosResponse<Configs>>}
 */
const getConfig = (idUser: number, idProgram: number) =>
  trackPromise(axios.post<Configs>(`${CINISERVICE}/getConfiguration`, { idUser, idProgram }), 'module');

/**
 * This API is the first to be called. Returns initial necessary data
 * @param {string} lang
 * @return {Promise<AxiosResponse<LookAndFeel>>}
 */
const getLookAndFeelSettings = (lang: string) =>
  trackPromise(
    axios.get<LookAndFeel>(`${CINISERVICE}/getLookAndFeel`, {
      params: { language: lang },
    }),
    'app',
  );

const getDownloadableManuals = () =>
  trackPromise(axios.get<DownloadableManuals>(`${CINISERVICE}/getDownloadableManuals`), 'modal');

const downloadManual = (section: string, item: string) =>
  trackPromise(axios.get(`${CINISERVICE}/downloadManual?section=${section}&item=${item}`), 'modal');

export default {
  getLookAndFeelSettings,
  getConfig,
  getDownloadableManuals,
  downloadManual,
};
